export default __webpack_public_path__ + "static/media/dapp.70067729.png";